import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { EditBusinessComponent } from 'app/components/business/editBusiness/editBusiness.component';
import { ISaveAdminBusiness } from 'app/models/admin/admin';
import { IBusinessView } from 'app/models/business/business';

import { IReportSelectItems, ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { ReportsService } from 'app/services/reports/reports.service';

@Component({
  selector: 'app-businessAdmin',
  templateUrl: './businessAdmin.component.html',
  styleUrls: ['./businessAdmin.component.scss']
})

export class BusinessAdminComponent implements OnInit {

  countySelected: string = '';
  countyList: ISelectItems[] = [];
  actionableComplaint: boolean = false;
  searchList: IBusinessView[] = [];
  resultsCount: number = 0;
  filter: string = '';
  businessId: string = '';
  // currentBusiness: IBusinessView;
  businessList: ISelectItems[] = [];
  getExemptTypeOptionsList: ISelectItems[] = [];
  getExemptStatusOptionsList: ISelectItems[] = [];
  // selectActionList: ISelectItems[] = [];
  selectStatusList: IReportSelectItems[] = [];
  statusList: IReportSelectItems[] = [];
  nonActionableList: ISelectItems[] = [];
  savedComplaints: boolean = false;
  exemptList: boolean = false;
  listCount: number = 0;

  currentSave: ISaveAdminBusiness = {
    businessId: 0,
    businessName: '',
    businessType: 0,
    active: false,
    exempt: false,
    businessAddress1: '',
    businessAddress2: '',
    businessCity: '',
    businessZip: '',
    businessZipExt: '',
    countyId: '',
    exemptCertificateDate: '',
    exemptStatusId: '',
    exemptTypeId: '',
    exemptSmokingAllowed: false,
    exemptApprovedBy: '',
    exemptEnteredBy: ''
  };

  // selectedViolations: string[] = [];

  displayedColumns: string[] = ['id', 'businessName', 'active', 'exempt', 'businessAddress1', 'businessCity',
    'businessZip', 'totalComplaints', 'merge'];
  dataSource = new MatTableDataSource<IBusinessView>(this.searchList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private modalService: MatDialog,
    public reportService: ReportsService) { }

  form = new UntypedFormGroup({
    searchText: new UntypedFormControl('', [Validators.maxLength(50), Validators.required]),
  });

  ngOnInit(): void {
    this.searchList = [];
    this.countyList = this.sharedService.countyDropDownList;
    this.savedComplaints = false;
    this.businessList = this.sharedService.businessTypeDropDownList;
    if (this.adminService.businessAdminSearch != '') {
      this.form.controls['searchText'].setValue(this.adminService.businessAdminSearch);
      this.getSearchBusinessData();
    }
  }

  getSearchBusinessData() {
    let searchText = String(this.form.controls['searchText'].value);
    if (searchText != null && searchText.length < 3) {
      this.sharedService.toastr.error("Search text must be at least 3 characters");
    }
    else {
      this.adminService.getBusinessAdminData(searchText).subscribe({
        next: response => {
          this.searchList = response;
          this.listCount = this.searchList.length;
          this.adminService.businessList = this.searchList;
          this.dataSource.data = this.searchList;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          if (response != null) {
            this.resultsCount = this.searchList.length;
          }
        },
        error: e => {
          this.sharedService.toastr.error("Could not get Business Data");
        },
      });
    }
  }

  rowClick(row: IBusinessView) {
    this.businessId = row.id == null ? '0' : row.id.toString();
    this.adminService.currentBusiness = row;
    this.actionableComplaint = row.active;

    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.data = {
      business: row,
      newBusiness: false
    };
    const dialogRef = this.modalService.open(EditBusinessComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getSearchBusinessData();
        }
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  newBusiness() {
    this.adminService.currentBusiness = null;

    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.data = {
      business: null,
      newBusiness: true,
    };
    const dialogRef = this.modalService.open(EditBusinessComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getSearchBusinessData();
        }
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  updateActionable(event: string) {
    this.actionableComplaint = event == 'true';
  }

  filterTable(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.filter = this.dataSource.filter;
  }

  mergeBusiness(row: IBusinessView) {
    this.adminService.currentBusiness = row;
    this.sharedService.doRedirect('admin/mergeBusiness');
  }

}
